<template>
  <div class="login-bg">
    <div class="login">
      <transition name="slide-fade">
        <el-card class="box-card login-box" v-if="show" v-loading="loading">
          <el-form @submit.native.prevent>
            <img src="../../../assets/logo.png" class="img-responsive img-logo" />
            <hr />
            <h5 class="card-title">Login</h5>
            <div class="numpad">

              <el-input readonly placeholder="Introdu PIN-ul" type="password" v-model="pin" controls="false">
                <el-button slot="append" @click="deleteOne()" icon="el-icon-back"></el-button>
              </el-input>

              <div class="input-numpad">
                <el-button @click="addValue(1)" class="buton">1</el-button>
                <el-button @click="addValue(2)" class="buton">2</el-button>
                <el-button @click="addValue(3)" class="buton">3</el-button>
                <el-button @click="addValue(4)" class="buton">4</el-button>
                <el-button @click="addValue(5)" class="buton">5</el-button>
                <el-button @click="addValue(6)" class="buton">6</el-button>
                <el-button @click="addValue(7)" class="buton">7</el-button>
                <el-button @click="addValue(8)" class="buton">8</el-button>
                <el-button @click="addValue(9)" class="buton">9</el-button>
                <el-button type="danger" @click="deletePin()" class="buton">Sterge</el-button>
                <el-button @click="addValue(0)" class="buton">0</el-button>
                <!-- <el-button type="success" native-type='submit' class="buton" :disabled="dezactiveazaButonLogin" @click="loginMecanic()">Intra</el-button>    -->
                <el-button type="success" native-type='submit' class="buton" @click="loginMecanic()">Intra</el-button>
              </div>
            </div>
          </el-form>
        </el-card>
      </transition>
    </div>
  </div>
</template>

<script>
import settings from "@/backend/LocalSettings";
import Vue from "vue";

export default {
  name: "login",
  components: {
  },
  data() {

    return {
      show: 0,
      loading: false,
      dezactiveazaButonLogin: true,
      pin: "",
    };
  },
  watch: {
    // pin(val) {
    //   if(val.length == 4) {
    //     this.dezactiveazaButonLogin = false;
    //   } else {
    //     this.dezactiveazaButonLogin = true;
    //   }
    // },
  },
  methods: {

    loginMecanic: async function () {
      if (this.pin.length === 0) return;
      if (settings.get_bearer() == '') {
        this.$message.error('Nu aveti drept de acces!');
        return
      }

      var response = await this.post('login/loginMecanic', { pin: this.pin, bearer: settings.get_bearer() });
      if (response.Token == null && response.Eroare == 'lipsa bearer') {
        this.$message.error('Tokenul nu corespunde!');
      } else if (response.Token == null && response.Eroare == 'IP nepermis') {
        this.$message.error('Accesul acestui utilizator este limitat!');
      } else if (response.Token != null) {
        settings.set_token(response.Token);
        settings.set_drepturi(response.Rights);
        settings.set_user_type(response.UserType);
        console.log('response', response);
        this.$router.push("/devize_draft");
      } else {
        this.$message.error('Date gresite');
      }
    },
    post: async function (url, args = {}) {
      this.loadingVisible = true;
      var response = await this.$http.post(url, args);
      this.loadingVisible = false;
      if (settings.verify_response(response)) return response.body;
    },
    addValue: async function (val) {
      this.pin += val;
    },
    deleteOne: async function () {
      if (this.pin === "" || this.pin.length <= 0) return;
      this.pin = this.pin.substring(0, this.pin.length - 1);
    },

    deletePin: async function () {
      this.pin = "";
    },

    handleKeyPress(event) {
      const key = event.key;
      if (!isNaN(parseInt(key)) && key.length === 1) {
        this.addValue(key);
      } else if (key === "Backspace") {
        this.deleteOne();
      } else if (key === "Enter") {
        this.loginMecanic();
      }
    },


  },
  mounted: function () {
    this.show = true;
    window.addEventListener("keydown", this.handleKeyPress);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyPress);
  },
};
</script>

<style lang="less" scoped>
.img-logo {
  max-height: 40px;
}

.login-box {
  margin: 50px auto;
  width: 320px;
}

.slide-fade-enter-active {
  transition: all 1.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(250px);
  opacity: 0;
}

.numpad-input {
  width: 100%;
  padding: 10px;
  text-align: center;
}

.input-numpad {
  margin-top: 20px;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
}

.buton {
  margin: 3px;
}
</style>
